<template>
  <div class="container">
    <!-- <div class="fppos">
      <div class="fppos-container">
        <div class="fppos-left">
          <div class="fppos-left-tit">关于丰派云POS</div>
          <div class="fppos-left-content">
            丰派云POS是专注零售领域的新零售SaaS系统，支持POS称重收银一体、进销存管理、全渠道营销、大数据BI分析、对接主流外卖平台、无人云值守等业务，助力中小型零售企业管理运营，为企业带来赋能增值，实现快速开店，轻松管店。
          </div>
        </div>
        <div class="fppos-right">
          <img v-lazy="require('@/assets/fppos.png')" alt="丰派云POS" />
        </div>
      </div>
    </div>  -->
    <div class="cloud-pos">
      <img src="@/assets/sycpbg.png" class="img" alt="" />
      <div class="cloud-txet-box">
        <div class="text-box">
          <p class="p1">丰派云POS</p>
          <div class="div">
            丰派云POS是专注零售领域的新零售SaaS系统，支持POS称重收银一体、进销存管理、全渠道营销、大数据BI分析、对接主流外卖平台、无人云值守等业务，助力中小型零售企业管理运营，为企业带来赋能增值，实现快速开店，轻松管店。
          </div>
          <div class="btn" @click="go">免费使用</div>
        </div>
      </div>
    </div>

    <div class="industry-box">
      <div class="industry-text">
        <p class="p1">各行各业一键开店</p>
        <p class="p2">
          支持多种零售、餐饮、服饰、母婴等多种行业，无需单独下载软件
        </p>
      </div>
      <div class="industry-img-box">
        <div class="industry-img industry-img1">
          <img class="img" src="@/assets/industry1.png" alt="" />
          <div class="text">便利商超</div>
        </div>
        <div class="industry-img industry-img2">
          <div class="text">美食餐饮</div>
          <img class="img" src="@/assets/industry2.png" alt="" />
        </div>
        <div class="industry-img industry-img3">
          <img class="img" src="@/assets/industry3.png" alt="" />
          <div class="text">服饰鞋包</div>
        </div>
        <div class="industry-img industry-img4">
          <div class="text">亲子母婴</div>
          <img class="img" src="@/assets/industry4.png" alt="" />
        </div>
      </div>
    </div>
    <div class="compatibility-box">
      <div class="compatibility-text">
        <p class="p1">硬件商业级兼容性</p>
        <p class="p2">
          无需担心硬件的兼容问题，丰派POS收银软件兼容市面上开店所需的扫描枪、钱箱、小票机、
        </p>
        <p class="p2">顾客显示器、标签机、通讯秤、AI智能秤等主流设备品牌。</p>
      </div>
      <div class="img-box">
        <img src="@/assets/yjjl.png" class="img" alt="" />
      </div>
    </div>
    <div class="system-box">
      <div class="system-text">
        <p class="p1">系统特色</p>
        <p class="p2">一秒了解丰派云POS收银系统</p>
      </div>
      <div class="system-time-box">
        <div class="system-time" v-for="item in featureList" :key="item.id">
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <div class="system-time1">{{ item.tit }}</div>
          <div class="system-time2">{{ item.tip }}</div>
          <div class="system-time2">{{ item.tip1 }}</div>
        </div>
      </div>
    </div>
    <div class="report-box">
      <div class="report-text-box">
        <div class="report-text">
          <div class="div1">更全面的数据分析报表 全方位提升营收</div>
          <div class="div2">
            更直观地了解数据，多对象、多角度地深挖营业数据价值，为商品结构调整、消费定位、营销活动、市场推广等方面做好第一手调研。
          </div>
        </div>
        <div class="report-img">
          <swiper :options="swiperOption6" ref="mySwiper">
            <!-- <swiper-slide v-for="item in listImg" :key="item.id"
        ><a href="#/web/webproduct"
          ><img class="swiper-slide-img" :src="item.img" alt="丰派收银" /></a
      ></swiper-slide> -->
            <swiper-slide>
              <!-- <div class="lb1">
                <img
                  class="swiper-slide-img"
                  src="@/assets/lbbg1.png"
                  alt="丰派收银"
                />
                <div class="text-box">
                  <p class="p1">订货商城</p>
                  <p>构建专属的全渠道营销订货平台</p>
                  <div class="btn">立即试用</div>
                </div>
              </div> -->
              <img src="@/assets/report.png" class="img" alt="" />
            </swiper-slide>
            <swiper-slide>
              <img src="@/assets/kll.png" class="img" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="function-box">
      <div class="function-text">
        <div class="div1">功能强大的收银系统</div>
        <div class="div2">足不出户即可管理门店，让O2O没有门槛</div>
      </div>
      <div class="function-text-img-box">
        <div class="function-left">
          <div class="text">
            丰派云POS收银系统内置多种功能模块，在家就可以管理门店，随时随地查看各种信息，销售数据、库存信息、员工情况尽在掌控之中，帮助您全方位管理您的收银系统。
          </div>
          <div class="feature-img-box">
            <div class="feature1">
              <img src="@/assets/image1.png" class="img" alt="" />
              <span class="span">精选优质服务商</span>
            </div>
            <div class="feature1">
              <img src="@/assets/imag2.png" class="img" alt="" />
              <span class="span">官方检测保质</span>
            </div>
            <div class="feature1">
              <img src="@/assets/imag3.png" class="img" alt="" />
              <span class="span">客服全程服务</span>
            </div>
            <div class="feature1">
              <img src="@/assets/image4.png" class="img" alt="" />
              <span class="span">退款售后无忧</span>
            </div>
          </div>
        </div>
        <div class="function-right">
          <div class="img-box">
            <img src="@/assets/spgl.png" class="img" alt="" />
            <div class="div-te">商品管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/xsgl.png" class="img" alt="" />
            <div class="div-te">销售管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/yxgl.png" class="img" alt="" />
            <div class="div-te">营销管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/ggts.png" class="img" alt="" />
            <div class="div-te">广告推送</div>
          </div>
          <div class="img-box">
            <img src="@/assets/zftj.png" class="img" alt="" />
            <div class="div-te">支付统计</div>
          </div>
          <div class="img-box">
            <img src="@/assets/kcgl.png" class="img" alt="" />
            <div class="div-te">库存管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/lsgl.png" class="img" alt="" />
            <div class="div-te">连锁管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/yggl.png" class="img" alt="" />
            <div class="div-te">员工管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/hygl.png" class="img" alt="" />
            <div class="div-te">会员管理</div>
          </div>
          <div class="img-box">
            <img src="@/assets/wdgl.png" class="img" alt="" />
            <div class="div-te">网店管理</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="industry">
      <div class="industry-container">
        <div class="industry-tit">各行各业一键开店</div>
        <div class="industry-tip">
          支持多种零售、餐饮、服饰、母婴等多种行业，无需单独下载软件
        </div>
        <div class="industry-content">
          <div class="industry-content-left wow animate__animated animate__slideInLeft">
            <div class="industry-content-left-item">
              <div class="industry-content-left-word">便利商超</div>
              <div class="industry-content-left-mask"></div>
              <img v-lazy="require('@/assets/industry1.png')" alt="丰派收银" />
            </div>
            <div class="industry-content-left-item wow animate__animated animate__slideInLeft">
              <div class="industry-content-left-word">服饰鞋包</div>
              <div class="industry-content-left-mask"></div>
              <img v-lazy="require('@/assets/industry2.png')" alt="丰派收银" />
            </div>
          </div>
          <div class="industry-content-midle wow animate__animated animate__slideInUp">
            <img v-lazy="require('@/assets/industry.png')" alt="丰派收银" />
          </div>
          <div class="industry-content-left">
            <div class="industry-content-left-item wow animate__animated animate__slideInRight">
              <div class="industry-content-left-word">美食餐饮</div>
              <div class="industry-content-left-mask"></div>
              <img v-lazy="require('@/assets/industry3.png')" alt="丰派收银" />
            </div>
            <div class="industry-content-left-item wow animate__animated animate__slideInRight">
              <div class="industry-content-left-word">母婴亲子</div>
              <div class="industry-content-left-mask"></div>
              <img v-lazy="require('@/assets/industry4.png')" alt="丰派收银" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="feature">
      <div class="feature-container">
        <div class="feature-tit wow animate__animated animate__slideInUp">系统特色</div>
        <div class="feature-tip wow animate__animated animate__slideInUp">一秒了解丰派云POS收银系统</div>
        <div class="feature-content wow animate__animated animate__slideInUp">
          <div
            class="feature-content-item"
            v-for="item of featureList.slice(0, 3)"
            :key="item.id"
          >
            <div class="feature-content-item-icon">
              <img v-lazy="item.img" alt="丰派收银" />
            </div>
            <div class="feature-content-item-tit">{{ item.tit }}</div>
            <div class="feature-content-item-tip">{{ item.tip }}</div>
          </div>
        </div>
        <div class="feature-content wow animate__animated animate__slideInUp" style="margin-top: 40px">
          <div
            class="feature-content-item"
            v-for="item of featureList.slice(3, 6)"
            :key="item.id"
          >
            <div class="feature-content-item-icon">
              <img v-lazy="item.img" alt="丰派收银" />
            </div>
            <div class="feature-content-item-tit">{{ item.tit }}</div>
            <div class="feature-content-item-tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="manage">
      <div class="manage-container">
        <div class="manage-left wow animate__animated animate__slideInLeft">
          <img v-lazy="require('@/assets/manage.png')" alt="丰派收银" />
        </div>
        <div class="manage-right wow animate__animated animate__slideInRight">
          <div class="manage-right-tit">
            功能强大的收银系统 足不出户即可管理门店
          </div>
          <div class="manage-right-content">
            丰派云POS收银系统内置多种功能模块，在家就可以管理门店，随时随地查看各种信息，销售数据、库存信息、员工情况尽在掌控之中，帮助您全方位管理您的收银系统。
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="fpdata">
      <div class="fpdata-container">
        <div class="fpdata-content wow animate__animated animate__slideInLeft">
          <div class="fpdata-content-tit">
            全面领先的数据分析 全方位提升营收
          </div>
          <div class="fpdata-content-tip">
            用户可以更直观地了解数据，多对象、多角度地深挖营业数据价值，为商品结构调整、消费定位、营销活动、市场推广等方面做好第一手调研。
          </div>
        </div>
        <div class="fpdata-img wow animate__animated animate__slideInRight">
          <img src="@/assets/fpdata.png" alt="丰派收银" />
        </div>
      </div>
    </div>
    <div class="equipment">
      <div class="equipment-container">
        <div class="equipment-left wow animate__animated animate__slideInLeft">
          <img v-lazy="require('@/assets/equipment.png')" alt="丰派收银" />
        </div>
        <div
          class="equipment-right wow animate__animated animate__slideInRight"
        >
          <div class="equipment-right-tit">硬件商业级兼容性</div>
          <div class="equipment-right-tip">
            用户无需担心硬件的兼容问题，开店所需的扫描枪、钱箱、小票机、顾客显示器、标签机、通讯称、AI智能秤等设备全都已经兼容妥当。
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "webproduct",
  data() {
    return {
      swiperOption6: {
        loop: true,
        // loopAdditionalSlides: 6,
        autoplay: {
          delay: 3000,
          // stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
      featureList: [
        {
          id: 1,
          img: require("@/assets/system1.png"),
          tit: "全新界面",
          tip: "界面全新升级，操作简单，用户可以快速上手，",
          tip1: "告别繁杂的培训学习",
        },
        {
          id: 2,
          img: require("@/assets/system2.png"),
          tit: "一体化营销",
          tip: "公众号、小程序、微信群、企业微信互联互通，",
          tip1: "流量变现快速高效，促销多样化",
        },
        {
          id: 3,
          img: require("@/assets/system3.png"),
          tit: "开放式API对接",
          tip: "开放式API支持打通各大会员系统、供应链、",
          tip1: "WMS系统、TMS系统等",
        },
        {
          id: 4,
          img: require("@/assets/system4.png"),
          tit: "全新框架",
          tip: "云技术高性能框架搭建的收银系统，性能稳定，",
          tip1: "简单易用，各机构数据实时同步",
        },
        {
          id: 5,
          img: require("@/assets/system5.png"),
          tit: "云端同步",
          tip: "采用全新同步技术和增加本地缓存库，遇到断网",
          tip1: "等突发情况开启自动保护机制",
        },
        {
          id: 6,
          img: require("@/assets/system6.png"),
          tit: "硬件无忧",
          tip: "兼容Windows、苹果IOS、安卓，不管使用什么",
          tip1: "设备，都有对应的客户端为您快速提升效率",
        },
      ],
    };
  },
  methods: {
    go() {
      location.href = "https://www.fp1123.com/fpPos/#/login";
    },
  },
  activated() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1420px;
  background: #fff;
  position: relative;
  top: 64px;
}
// .fppos {
//   width: 100%;
//   height: 575px;
//   background: #fff;
//   display: flex;
//   justify-content: center;
//   padding: 66px;
//   .fppos-container {
//     width: 1200px;
//     height: 443px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     .fppos-left {
//       width: 534px;
//       height: 164px;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-around;
//       .fppos-left-tit {
//         font-weight: 500;
//         font-size: 30px;
//         color: #353535;
//       }
//       .fppos-left-content {
//         margin-top: 50px;
//         font-weight: 350;
//         font-size: 14px;
//         color: #666666;
//       }
//     }
//     .fppos-right {
//       margin-left: 106px;
//       width: 560px;
//       height: 420px;
//       img {
//         width: 560px;
//         height: 420px;
//       }
//     }
//   }
// }
.cloud-pos {
  width: 100%;
  min-width: 1420px;
  position: relative;
  .img {
    width: 100%;
  }
  .cloud-txet-box {
    position: absolute;
    width: 1420px;
    left: 50%;
    transform: translateX(-50%);
    top: 22%;
    .text-box {
      width: 520px;
    }
    .p1 {
      font-size: 64px;
      line-height: 96px;
      color: #292929;
      margin-bottom: 8%;
    }
    .div {
      font-size: 16px;
      line-height: 28px;
      color: #637392;
    }
    .btn {
      margin-top: 6%;
      cursor: pointer;
      width: 164px;
      height: 54px;
      border-radius: 6px;
      background: #336fff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      text-align: center;
      line-height: 54px;
      color: #fff;
    }
    .btn:hover {
      background: #5c8cff;
    }
  }
}
.industry-box {
  width: 100%;
  min-width: 1420px;
  height: 720px;
  background: #fcfcff;
  padding-top: 60px;
  .industry-text {
    text-align: center;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 0;
    }
    .p2 {
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
      margin-top: 12px;
    }
  }
  .industry-img-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: 80px;
    justify-content: space-between;
    overflow: hidden;
    .industry-img {
      position: relative;
      cursor: pointer;
      width: 292.5px;
      .img {
        width: 100%;
      }
      .text {
        height: 46px;
        text-align: center;
        line-height: 46px;
        font-size: 20px;
        color: #555555;
      }
    }
    .industry-img1::before {
      content: "";
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: -200%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/cs.png");
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 1s;
    }
    .industry-img1:hover:before {
      transition: all 1s;
      content: "";
      position: absolute;
      opacity: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/cs.png");
      background-repeat: no-repeat;
      background-position: center center;
    }
    .industry-img2::before {
      content: "";
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: -200%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/ms1.png");
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 1s;
    }
    .industry-img2:hover:before {
      transition: all 1s;
      content: "";
      position: absolute;
      opacity: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/ms1.png");
      background-repeat: no-repeat;
      background-position: center center;
    }
    .industry-img3::before {
      content: "";
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: -200%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/fs1.png");
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 1s;
    }
    .industry-img3:hover:before {
      transition: all 1s;
      content: "";
      position: absolute;
      opacity: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/fs1.png");
      background-repeat: no-repeat;
      background-position: center center;
    }
    .industry-img4::before {
      content: "";
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: -200%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/my1.png");
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 1s;
    }
    .industry-img4:hover:before {
      transition: all 1s;
      content: "";
      position: absolute;
      opacity: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0%;
      background: rgba(0, 0, 0, 0.4);
      background-image: url("~@/assets/my1.png");
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}
.compatibility-box {
  width: 100%;
  min-width: 1420px;
  height: 847px;
  background: #fcfcff;
  padding-top: 60px;
  .compatibility-text {
    text-align: center;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 12px;
    }
    .p2 {
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
      margin-bottom: 0;
    }
  }
  .img-box {
    width: 1200px;
    margin: 0 auto;
    margin-top: 48px;
    .img {
      width: 100%;
    }
  }
}
.system-box {
  width: 100%;
  min-width: 1420px;
  height: 854px;
  background: #242933;
  padding-top: 60px;
  .system-text {
    text-align: center;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #ffffff;
      margin-bottom: 12px;
    }
    .p2 {
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      margin-bottom: 0;
    }
  }
  .system-time-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: 36px;
    justify-content: space-between;
    flex-wrap: wrap;
    .system-time {
      width: 366.67px;
      height: 272px;
      box-shadow: 4px 8px 20px rgba(0, 0, 0, 0.25);
      border-radius: 6px;
      margin-bottom: 40px;
      cursor: pointer;
      &:hover {
        transition: all 1s;
        // transition: 300s;
        box-shadow: inset -8px -8px 20px rgba(255, 255, 255, 0.06),
          inset 8px 8px 20px rgba(0, 0, 0, 0.4);
      }
      .img {
        width: 100px;
        height: 100px;
        margin: 30px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .system-time1 {
        text-align: center;
        font-size: 18px;
        line-height: 26px;
        color: #fff;
        margin-bottom: 10px;
      }
      .system-time2 {
        text-align: center;
        font-size: 14px;
        line-height: 24px;
        color: #fff;
      }
    }
  }
}
.report-box {
  width: 100%;
  min-width: 1420px;
  height: 560px;
  .report-text-box {
    width: 1200px;
    margin: 0 auto;
    margin-top: 80px;
    display: flex;
    align-items: center;
    .report-text {
      width: 440px;
      .div1 {
        width: 81%;
        font-size: 36px;
        line-height: 56px;
        color: #292929;
      }
      .div2 {
        margin-top: 50px;
        font-size: 16px;
        line-height: 26px;
        color: #666666;
      }
    }
    .report-img {
      margin-left: 90px;
      width: 670px;
      .img {
        width: 670px;
      }
    }
  }
}
.function-box {
  width: 100%;
  min-width: 1420px;
  height: 636px;
  background: #f8faff;
  padding-top: 66px;
  .div1 {
    text-align: center;
    font-size: 27px;
    line-height: 48px;
    color: #353535;
  }
  .div2 {
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    color: #666666;
    margin-top: 14px;
  }
  .function-text-img-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: 80px;
    align-items: center;
    .function-left {
      width: 420px;
      padding: 10px;
      margin-right: 50px;
      .text {
        width: 420px;
        font-size: 14px;
        line-height: 26px;
        color: #666;
      }
      .feature-img-box {
        margin-top: 60px;
        width: 100%;
        flex-wrap: wrap;
        display: flex;
        justify-content: space-between;
        padding-right: 40px;
        .feature1 {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .img {
            width: 16px;
            height: 16px;
            margin: 0 12px;
          }
          .span {
            font-size: 15px;
            line-height: 24px;
            color: #253554;
          }
        }
      }
    }
    .function-right {
      width: 730px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .img-box {
        width: 130px;
        height: 136px;
        background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: -8px -8px 20px #ffffff, 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 10px;
        padding: 20px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        cursor: pointer;
        transition: all 0.2s;
        transform: translateY(0);
        &:hover {
          transition: all 0.2s;
          transform: translateY(-6px);
        }
        .img {
          width: 60px;
          height: 60px;
        }
        .div-te {
          font-size: 14px;
          line-height: 26px;
          color: #253554;
          text-align: center;
        }
      }
    }
  }
}

.feature {
  width: 100%;
  height: 870px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 66px 44px 88px 44px;
  .feature-container {
    width: 1200px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .feature-tit {
      //   text-align: center;
      font-weight: 500;
      font-size: 30px;
      color: #353535;
    }
    .feature-tip {
      //   text-align: center;
      margin-top: 14px;
      font-weight: 350;
      font-size: 20px;
      color: #666666;
    }
    .feature-content {
      width: 1200px;
      margin-top: 36px;
      display: flex;
      flex-wrap: wrap;
      .feature-content-item {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        width: 366px;
        height: 282px;
        padding: 40px 33px 30px;
        background: #ffffff;
        box-shadow: 0px 0px 40px rgba(85, 152, 215, 0.12);
        border-radius: 10px;
        margin-right: 50px;
        &:last-child {
          margin-right: 0;
        }
        .feature-content-item-icon {
          width: 100px;
          height: 100px;
          overflow: hidden;
          img {
            width: 100px;
            height: 100px;
          }
        }
        .feature-content-item-tit {
          margin-top: 28px;
          font-weight: 350;
          font-size: 20px;
          color: #353535;
        }
        .feature-content-item-tip {
          margin-top: 10px;
          text-align: center;
          font-weight: 350;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
}
.manage {
  width: 100%;
  height: 649px;
  background: #fff;
  display: flex;
  justify-content: center;
  .manage-container {
    width: 1200px;
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    align-items: center;
    .manage-left {
      width: 570px;
      height: 517px;
      overflow: hidden;
      img {
        width: 570px;
        height: 517px;
      }
    }
    .manage-right {
      margin-left: 80px;
      width: 550px;
      height: 174px;
      .manage-right-tit {
        width: 300px;
        font-weight: 500;
        font-size: 30px;
        color: #353535;
      }
      .manage-right-content {
        margin-top: 50px;
        font-weight: 350;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
.fpdata {
  width: 100%;
  height: 714px;
  background: #fff;
  display: flex;
  justify-content: center;
  .fpdata-container {
    position: relative;
    width: 1200px;
    height: 714px;
    display: flex;
    align-items: center;
    // background: url("~@/assets/fpdata.png") no-repeat 100% 50%;
    .fpdata-img {
      position: absolute;
      // top:50%;
      top: 140px;
      right: 0;
      z-index: 10;
      // transform: translateY(-50%);
    }
    .fpdata-content {
      position: absolute;
      top: 270px;
      left: 0;
      // transform: translateY(-50%);
      z-index: 20;
      width: 536px;
      //   height: 174px;
      .fpdata-content-tit {
        width: 270px;
        font-weight: 500;
        font-size: 30px;
        color: #353535;
      }
      .fpdata-content-tip {
        width: 536px;
        margin-top: 50px;
        font-weight: 350;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
.equipment {
  width: 100%;
  height: 608px;
  padding: 44px 44px 64px;
  background: #fff;
  display: flex;
  justify-content: center;
  .equipment-container {
    width: 1200px;
    display: flex;
    align-items: center;
    .equipment-left {
      width: 536px;
      height: 500px;
      overflow: hidden;
      img {
        width: 536px;
        height: 500px;
      }
    }
    .equipment-right {
      margin-left: 114px;
      width: 550px;
      .equipment-right-tit {
        font-weight: 500;
        font-size: 30px;
        color: #353535;
      }
      .equipment-right-tip {
        margin-top: 50px;
        font-weight: 350;
        font-size: 16px;
        color: #666666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/product.vue